export const animations = Object.freeze({
    FadeInCenter: 'fade-in-center',
    FadeOutCenter: 'fade-out-center',

    FadeInLeft: 'fade-in-left',
    FadeInTop: 'fade-in-top',
    FadeInRight: 'fade-in-right',
    FadeInBottom: 'fade-in-bottom',
    FadeIn: 'fade-in',

    FadeOutLeft: 'fade-out-left',
    FadeOutTop: 'fade-out-top',
    FadeOutRight: 'fade-out-right',
    FadeOutBottom: 'fade-out-bottom',

    FadeOut: 'fade-out',
    Hidden: 'hidden',
    Visible: 'visible',
})